import { DataGrid, GridColumnsConfigProvider } from '@finbeat/react-toolkit';
import Money from 'components/Common/Money';
import { Product } from 'models/api/order';
import { Trans } from 'react-i18next';

const ProductsTable = ({ products }: { products: Product[] }) => {
    return (
        <GridColumnsConfigProvider<Product>
            storagePath="order-products-grid"
            initColumns={[
                {
                    key: 'productName',
                    name: <Trans i18nKey="BackOfficeProductName" />,
                },
                {
                    key: 'productCnt',
                    name: <Trans i18nKey="BackOfficeProductCount" />,
                },
                {
                    key: 'productCost',
                    name: <Trans i18nKey="BackOfficeProductCost" />,
                    formatter: ({ row }) => <Money value={row.productCost} />,
                },
                {
                    key: 'productSum',
                    name: <Trans i18nKey="BackOfficeProductTotalSum" />,
                    formatter: ({ row }) => <Money value={row.productSum} />,
                },
            ]}
        >
            <DataGrid<Product>
                rows={products}
                lineHeight={35}
                reactDataGreedProps={{
                    defaultColumnOptions: {
                        sortable: true,
                        resizable: true,
                    },
                }}
                blockSize={55 + products.length * 35}
                minBlockSize={90}                
            />
        </GridColumnsConfigProvider>
    );
};

export default ProductsTable;
